import { Box } from '@mui/material';
import React from 'react';

interface Props {
  sidenav?: React.ReactNode;
  content: React.ReactNode;
}

/**
 * Main wrapper component that renders the application layout.
 * When sidenav is provided, it displays a sidebar alongside the main content.
 * When sidenav is omitted, it renders only the main content in fullscreen mode.
 */
export function MainWrapper(props: Props) {
  return (
    <Box
      className="main-wrapper"
      sx={{
        height: '100%',
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      {props.sidenav && <Box sx={{ flexShrink: 0 }}>{props.sidenav}</Box>}
      <Box
        component="main"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          overflowX: 'hidden',
          backgroundColor: (theme) => theme.palette.background.default,
        }}
      >
        {props.content}
      </Box>
    </Box>
  );
}
